import React, { CSSProperties } from 'react';
import { Tv } from 'lucide-react';

interface Props {
  onClick: () => void;
  isLive: boolean;
}

export function JoinLivestreamButton({ onClick, isLive }: Props): React.ReactElement | null {
  if (!isLive) {
    return null;
  }

  return (
    <button
      style={styles.button}
      onClick={onClick}
      type="button">
      <Tv size={18} color="white" style={styles.icon} />
      <span style={styles.text}>Join Livestream</span>
    </button>
  );
}

const styles: Record<string, CSSProperties> = {
  button: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#4a7bb7',
    borderRadius: '20px',
    padding: '10px 20px',
    minWidth: '140px',
    border: 'none',
    cursor: 'pointer',
    transition: 'opacity 0.2s',
  },
  icon: {
    marginRight: '6px',
  },
  text: {
    color: '#ffffff',
    fontSize: '14px',
    fontWeight: 600,
  },
};
